// extracted by mini-css-extract-plugin
module.exports = {"topic":"Topic_topic__1n3OH","name":"Topic_name__3WJ2u","circle":"Topic_circle__3tZO8","row":"Topic_row__1RF4T","actions":"Topic_actions__MPh1u"};